import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import Button from './common/Button'
import Input from './common/Input'

export default function HolidayForm({ initialValues, onSubmit, loading, onCancel }) {
    return (
        <Formik initialValues={{ title: '', date: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    label="Назваие"
                    name="title"
                    disabled={loading}
                    placeholder="Введите название"
                    validate={required} />

                <Input
                    label="Дата"
                    name="date"
                    type="date"
                    disabled={loading}
                    placeholder="Введите дата"
                    validate={required} />

                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
